export interface ConfigVariantSite {
  Lite?: boolean;
}

interface ConfigVariant {
  name: string;
  appliesTo(site: ConfigVariantSite): boolean;
}

function isLiteSite(site: ConfigVariantSite): boolean {
  return site.Lite === true;
}

export const CONFIG_VARIANTS: ConfigVariant[] = [{ name: 'lite', appliesTo: isLiteSite }];

export function getConfigVariants(
  site?: ConfigVariantSite,
  variants: ConfigVariant[] = CONFIG_VARIANTS,
): string[] {
  const names: string[] = [];
  if (!site) {
    return names;
  }
  for (const variant of variants) {
    if (variant.appliesTo(site)) {
      names.push(variant.name);
    }
  }
  return names;
}

export function getVariantFleetDomain(domain: string, variant: string): string {
  return `${domain}-${variant}-fleet`;
}

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isEmptyConfigValue(value: unknown): boolean {
  return (
    value === undefined ||
    value === null ||
    value === '' ||
    (Array.isArray(value) && value.length === 0) ||
    (isPlainObject(value) && Object.keys(value).length === 0)
  );
}

export function mergeConfigLayers(
  base: Record<string, any> | undefined,
  layers: (Record<string, any> | undefined)[],
): Record<string, any> {
  const result: Record<string, any> = { ...(base ?? {}) };
  for (const layer of layers) {
    for (const [key, value] of Object.entries(layer ?? {})) {
      if (!isEmptyConfigValue(value)) {
        result[key] =
          isPlainObject(value) && isPlainObject(result[key])
            ? mergeConfigLayers(result[key], [value])
            : value;
      }
    }
  }
  return result;
}
